import React from "react";
import { Link } from "react-router-dom";

import LOGO from "../data/EPLOGO.png";

const QUICK_LINKS = [
  { label: "Home",     to: "/" },
  { label: "About",    to: "/about" },
  { label: "Products", to: "/products" },
  { label: "Services", to: "/services" },
  { label: "Contact",  to: "/contact" },
];

const PRODUCT_LINKS = [
  "Generics",
  "Branded Medicines",
  "Over-the-Counter",
  "Parallel Imports",
  "Consumables",
];

function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="container">

        <div className="site-footer-grid">

          {/* Col 1 — Brand */}
          <div>
            <div className="footer-logo">
              <img src={LOGO} alt="Etiquette Pharmaceuticals" className="footer-logo-img" />
              <span className="footer-logo-name">Etiquette Pharmaceuticals</span>
            </div>
            <p className="footer-desc">
              Wholesale pharmaceutical and healthcare supply structured for
              trade buyers, account relationships, and better stock visibility.
            </p>
            <p className="footer-rc">Registered in Nigeria · RC 1727250</p>
          </div>

          {/* Col 2 — Quick links */}
          <div>
            <p className="footer-col-heading">Quick Links</p>
            <nav className="footer-links" aria-label="Footer navigation">
              {QUICK_LINKS.map((link) => (
                <Link key={link.to} to={link.to} className="footer-link">
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Col 3 — Products */}
          <div>
            <p className="footer-col-heading">Products</p>
            <div className="footer-links">
              {PRODUCT_LINKS.map((name) => (
                <Link key={name} to="/products" className="footer-link">
                  {name}
                </Link>
              ))}
            </div>
          </div>

          {/* Col 4 — Contact */}
          <div>
            <p className="footer-col-heading">Contact</p>

            <div className="footer-contact-item">
              <span className="footer-contact-label">Phone</span>
              <a href="tel:+2348061298497" className="footer-contact-value footer-link">
                +234 806 129 8497
              </a>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-label">Email</span>
              <a href="mailto:info@etiquettepharmaceuticals.com" className="footer-contact-value footer-link">
                info@etiquettepharmaceuticals.com
              </a>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-label">Address</span>
              <span className="footer-contact-value">
                House 12-14, S. Zakari Close,<br />
                NAF Valley Estate, Asokoro, Abuja
              </span>
            </div>

            <div className="footer-contact-item">
              <span className="footer-contact-label">Hours</span>
              <span className="footer-contact-value">Mon – Fri: 8:00am – 5:00pm WAT</span>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="site-footer-bottom">
          <p>© {new Date().getFullYear()} Etiquette Pharmaceuticals Limited. All rights reserved.</p>
          <div className="footer-bottom-right">
            <span className="footer-pcn-badge">PCN Licensed</span>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default SiteFooter;
